import { Component, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ManageAuctionFeesService } from '../manage-auction-fees.service';
import { AuctionFeesSearch } from '../models/AuctionFees';
import { loanTypeConst, typeOfSaleConst, feeTypeConst} from '../auctionFees.const';
//import { ForeclosureAuctionSearchParams } from '../models/ForeclosureAuction'

@Component({
  selector: 'app-add-auction-fees',
  templateUrl: './add-auction-fees.component.html',
  styleUrls: ['./add-auction-fees.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ManageAuctionFeesService]
})

export class AddAuctionFeesComponent implements OnInit {

  @Output() cancelAddEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() objMessage = new EventEmitter<{}>();
  @Output() reload = new EventEmitter<boolean>();

  /* ----- Form Groups and Controls ----*/
  public addAuctionFeesForm: FormGroup = new FormGroup({
    ClientId: new FormControl('', Validators.required),
    LoanType: new FormControl('', Validators.required),
    TypeOfSale: new FormControl('', null),
    FeeType: new FormControl('', Validators.required),
    FeeAmount: new FormControl('', [Validators.required, Validators.pattern(/^[0-9]\d*(\.\d*)?$/)])
  });
  clientIdControl = this.addAuctionFeesForm.get('ClientId');
  loanTypeControl = this.addAuctionFeesForm.get('LoanType');
  typeOfSaleControl = this.addAuctionFeesForm.get('TypeOfSale');
  feeTypeControl = this.addAuctionFeesForm.get('FeeType');
  feeAmountControl = this.addAuctionFeesForm.get('FeeAmount');
  processing: boolean;
  searchParams: AuctionFeesSearch;
  loanType = loanTypeConst;
  typeOfSale = typeOfSaleConst;
  feeType = feeTypeConst;
  selectedTypeOfSale:  any[];
  selectedClientId: any[];
  selectedLoantype: any[];
  clientId : any[];
  formatTypevalue: string = '';

  constructor(private manageAuctionFeesService: ManageAuctionFeesService) { }

  ngOnInit() {
    this.manageAuctionFeesService.getUniqueClientID().subscribe(res =>{
      this.clientId = res.data;
    })
  }

  hideAddAuctionFeesForm(): void {
    this.cancelAddEvent.emit(false);
    this.reload.emit(false);
    this.setBreadCrumbs.emit([{ label: 'Manage Foreclosure Auction Location' }]);
  }

  formatType(event) : void {
   this.formatTypevalue = (event.value == 'Percentage of Sale' || event.value == 'Percentage of Lesser of Sale Price and Total Debt') ? '%' : '$';
  }

  submitAddAuctionFeesForm(): void {
    this.searchParams = <AuctionFeesSearch>{};
    this.searchParams.ClientId = this.clientIdControl.value == (null || undefined) ? '' : this.clientIdControl.value;
    this.searchParams.LoanType = this.loanTypeControl.value == (null || undefined) ? '' : this.loanTypeControl.value;
    this.searchParams.TypeOfSale = this.typeOfSaleControl.value == (null || undefined) ? '' : this.typeOfSaleControl.value;
    this.searchParams.FeeType = this.feeTypeControl.value == (null || undefined) ? '' : this.feeTypeControl.value;
    this.searchParams.FeeAmount = this.feeAmountControl.value == (null || undefined) ? '' : this.feeAmountControl.value;
    this.processing = true;
    this.manageAuctionFeesService.save(this.searchParams).subscribe(res => {
      this.processing = false;
      if (!res.error && res.data.length > 0) {
        this.objMessage.emit({ 'severity': 'success', 'detail': 'Auction Fees  added successfully.' });
        this.cancelAddEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'Manage Auction Fees' }]);
      } else if (res.error && res.data.length == 0) {
        this.objMessage.emit({ 'severity': 'error', 'detail': res.messages[0] });
      }
    }, error => {
      this.processing = false;
      this.objMessage.emit({ 'severity': 'error', 'detail': error.message });
    })
  }
}
